<template>
  <div class="app-container">
    <el-row>
      <!--部门数据-->
      <el-col :span="3.5" :xs="24">
        <div class="head-container">
          <el-input
            v-model="name"
            placeholder="请输入部门名称"
            clearable
            size="small"
            prefix-icon="el-icon-search"
            style="margin-bottom: 20px"
          />
          <el-tree
            :data="deptOptions"
            :props="defaultProps"
            :expand-on-click-node="false"
            :filter-node-method="filterNode"
            ref="tree"
            node-key="id"
            default-expand-all
            highlight-current
            @node-click="handleNodeClick"
          />
        </div>
      </el-col>
      <!--用户数据-->
      <el-col :span="20" :xs="24">
        <el-form
          :model="queryUser"
          ref="queryForm"
          size="small"
          :inline="true"
          v-show="showSearch"
          label-width="80px"
        >
          <el-form-item label="用户姓名" prop="trueName">
            <el-input
              v-model="queryUser.trueName"
              placeholder="请输入用户姓名"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="手机号码" prop="phone">
            <el-input
              v-model="queryUser.phone"
              placeholder="请输入手机号码"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select
              v-model="queryUser.status"
              placeholder="用户状态"
              clearable
              style="width: 240px"
            >
              <el-option
                v-for="dict in optionsZ"
                :key="dict.value"
                :label="dict.dictLabel"
                :value="dict.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              size="mini"
              @click="handleQuery"
              >搜索</el-button
            >
            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
              >重置</el-button
            >
          </el-form-item>
        </el-form>

        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button
              type="primary"
              plain
              icon="el-icon-plus"
              size="mini"
              @click="handleAdd"
              >新增</el-button
            >
          </el-col>
          <!-- <el-col :span="1.5">
            <el-button
              type="danger"
              plain
              icon="el-icon-delete"
              size="mini"
              :disabled="multiple"
              @click="handleDelete"
              >删除</el-button
            >
          </el-col> -->
          <right-toolbar
            :showSearch.sync="showSearch"
            @queryTable="getUserList"
            :columns="columns"
          ></right-toolbar>
        </el-row>

        <el-table
          class="compact-table"
          v-loading="loading"
          :data="userList"
          height="calc(100vh - 300px)"
          @selection-change="handleSelectionChange"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <el-table-column type="selection" width="50" align="center" />
          <el-table-column
            label="用户名"
            align="center"
            key="userName"
            prop="userName"
            v-if="columns[0].visible"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="	姓名"
            align="center"
            key="trueName"
            prop="trueName"
            v-if="columns[1].visible"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="部门"
            align="center"
            key="departmentName"
            prop="departmentName"
            v-if="columns[2].visible"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              {{ getDeptNameById(scope.row.departmentId) }}
            </template>
          </el-table-column>
          <!-- 岗位 -->
          <el-table-column
            label="岗位"
            align="center"
            key="roleName"
            prop="roleName"
            v-if="columns[3].visible"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="手机号码"
            align="center"
            key="phone"
            prop="phone"
            v-if="columns[4].visible"
            width="120"
          />
          <el-table-column
            label="状态"
            align="center"
            key="status"
            v-if="columns[5].visible"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isValid"
                :active-value="1"
                :inactive-value="2"
                @change="handleStatusChange(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            align="center"
            prop="createDate"
            v-if="columns[6].visible"
            width="160"
          
          :formatter="dateTimeTwoLine"
          class-name="cell-two-line"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.createDate }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="160"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope" v-if="scope.row.userId !== 1">
              <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="handleUpdate(scope.row)"
                >修改</el-button
              >
              <!-- <el-button
                size="mini"
                type="text"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
                >删除</el-button
              > -->
              <el-dropdown
                size="mini"
                @command="(command) => handleCommand(command, scope.row)"
              >
                <el-button size="mini" type="text" icon="el-icon-d-arrow-right"
                  >更多</el-button
                >
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="handleResetPwd" icon="el-icon-key"
                    >重置密码</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryUser.page"
          :limit.sync="queryUser.limit"
          @pagination="getUserList"
        />
      </el-col>
    </el-row>

    <!-- 添加或修改用户配置对话框 -->
    <el-dialog
      :title="title"
      :visible.sync="open"
      width="600px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="92px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="trueName">
              <el-input
                v-model="form.trueName"
                placeholder="请输入用户昵称"
                maxlength="30"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="归属部门" prop="departmentId">
              <treeselect
                v-model="form.departmentId"
                :options="deptOptions"
                :show-count="true"
                :normalizer="normalizer"
                placeholder="请选择归属部门"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="手机号码" prop="phone">
              <el-input
                v-model="form.phone"
                placeholder="请输入手机号码"
                maxlength="11"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="form.email"
                placeholder="请输入邮箱"
                maxlength="50"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              v-if="form.id == undefined"
              label="用户名称"
              prop="userName"
            >
              <el-input
                v-model="form.userName"
                placeholder="请输入用户名称"
                maxlength="30"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              v-if="form.id == undefined"
              label="用户密码"
              prop="userPwd"
            >
              <el-input
                v-model="form.userPwd"
                placeholder="请输入用户密码"
                type="password"
                maxlength="20"
                show-password
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户性别" prop="sexId">
              <el-select v-model="form.sexId" placeholder="请选择性别">
                <el-option
                  v-for="dict in sexOptions"
                  :key="dict.id"
                  :label="dict.label"
                  :value="dict.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="form.isValid">
                <el-radio
                  v-for="dict in statusOptions"
                  :key="dict.value"
                  :label="dict.value"
                  >{{ dict.label }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <!-- <el-form-item label="岗位">
				<el-select
				  v-model="form.postIds"
				  multiple
				  placeholder="请选择岗位"
				>
				  <el-option
					v-for="item in postOptions"
					:key="item.postId"
					:label="item.postName"
					:value="item.postId"
					:disabled="item.status == 1"
				  ></el-option>
				</el-select>
			  </el-form-item> -->
          </el-col>
          <el-col :span="12">
            <el-form-item label="角色" prop="roleIds">
              <el-select
                v-model="form.roleIds"
                multiple
                placeholder="请选择角色"
              >
                <el-option
                  v-for="item in roleOptions"
                  :key="item.id"
                  :label="item.roleName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                v-model="form.remark"
                type="textarea"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 用户导入对话框 -->
    <el-dialog
      :title="upload.title"
      :visible.sync="upload.open"
      width="400px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-upload
        ref="upload"
        :limit="1"
        accept=".xlsx, .xls"
        :headers="upload.headers"
        :action="upload.url + '?updateSupport=' + upload.updateSupport"
        :disabled="upload.isUploading"
        :on-progress="handleFileUploadProgress"
        :on-success="handleFileSuccess"
        :auto-upload="false"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip text-center" slot="tip">
          <div class="el-upload__tip" slot="tip">
            <el-checkbox v-model="upload.updateSupport" />
            是否更新已经存在的用户数据
          </div>
          <span>仅允许导入xls、xlsx格式文件。</span>
          <el-link
            type="primary"
            :underline="false"
            style="font-size: 14px; vertical-align: baseline"
            @click="importTemplate"
            >下载模板</el-link
          >
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFileForm">确 定</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  postUserInsert,
  postUserDelete,
  getUserList,
  postUserUpdate,
  getIDUser,
  restPassword,
  postUserStatus,
} from "@/api/plat/PlatStaff";
import { getTRoleSelectByPage } from "@/api/plat/PosMana";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  name: "User",
  // dicts: ["sys_normal_disable", "sys_user_sex"],
  components: { Treeselect },
  data() {
    return {
      sexOptions: [
        {
          value: 37,
          label: "男",
        },
        {
          value: 38,
          label: "女",
        },
      ],
      statusOptions: [
        {
          value: 1,
          label: "启用",
        },
        {
          value: 0,
          label: "停用",
        },
      ],
      // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 用户表格数据
      userList: [],
      // 弹出层标题
      title: "",
      // 部门树选项
      deptOptions: [],
      // 是否显示弹出层
      open: false,
      // 部门名称
      name: undefined,
      // 默认密码
      initPassword: undefined,
      // 日期范围
      dateRange: [],
      // 岗位选项
      postOptions: [],
      // 角色选项
      roleOptions: [],
      // 表单参数
      form: {},
      defaultProps: {
        children: "children",
        label: "name",
      },
      optionsZ: [
        {
          dictLabel: "正常",
          dictValue: 1,
        },
        {
          dictLabel: "停用",
          dictValue: 2,
        },
      ],
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: "",
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        //   headers: { Authorization: "Bearer " + getToken() },
        // 上传的地址
        url: process.env.VUE_APP_BASE_API + "/system/user/importData",
      },
      // 查询参数
      queryUser: {
        limit: 10,
        page: 1,
        trueName: "",
        phone: "",
        status: "",
        departmentId: "",
        orderBy: "",
      },
      // 角色查询参数
      queryRole: {
        limit: 999,
        page: 1,
        data: {
          roleName: "",
          status: "",
        },
        orderBy: "",
      },
      // 列信息
      columns: [
        // { key: 0, label: `用户编号`, visible: true },
        { key: 0, label: `用户名称`, visible: true },
        { key: 1, label: `用户昵称`, visible: true },
        { key: 2, label: `部门`, visible: true },
        { key: 3, label: `岗位`, visible: true },
        { key: 4, label: `手机号码`, visible: true },
        { key: 5, label: `状态`, visible: true },
        { key: 6, label: `创建时间`, visible: true },
      ],
      // 表单校验
      rules: {
        userName: [
          { required: true, message: "用户名称不能为空", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "用户名称长度必须介于 2 和 20 之间",
            trigger: "blur",
          },
        ],
        email: [
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur"],
            required: true,
          },
        ],
        trueName: [
          { required: true, message: "用户昵称不能为空", trigger: "blur" },
        ],
        sexId: [{ required: true, message: "性别不能为空", trigger: "change" }],
        departmentId: [
          { required: true, message: "部门不能为空", trigger: "change" },
        ],
        userPwd: [
          { required: true, message: "用户密码不能为空", trigger: "blur" },
          {
            min: 5,
            max: 20,
            message: "用户密码长度必须介于 5 和 20 之间",
            trigger: "blur",
          },
        ],
        roleIds: [
          {
            required: true,
            message: "角色不能为空",
            trigger: ["blur", "change"],
          },
        ],
        phone: [
          {
            required: true,
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    // 根据名称筛选部门树
    name(val) {
      this.$refs.tree.filter(val);
    },
  },
  async created() {
    this.getUserList();
    this.getRoleList();
    let deptArr = await this.getDimTableDeptByIds([145, 213, 214, 215, 216]);
    this.deptOptions = deptArr.data;
  },
  methods: {
    /** 查询用户列表 */
    async getUserList() {
      this.loading = true;
      let { data, count } = await getUserList(this.queryUser);
      this.userList = data;
      this.total = count;
      this.loading = false;
    },
    /** 查询角色列表 */
    async getRoleList() {
      let role = await getTRoleSelectByPage(this.queryRole);
      this.roleOptions = role.data;
    },
    /** 转换部门数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      };
    },

    // 筛选节点
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 节点单击事件
    handleNodeClick(data) {
      // 判断是否为父级中心（有children且children长度大于0）
      if (data.children && data.children.length > 0) {
        // 父级中心不发送请求
        return;
      }
      this.queryUser.departmentId = data.id;
      this.handleQuery();
    },
    // 用户状态修改
    handleStatusChange(row) {
      let text = row.isValid === 1 ? "启用" : "停用";
      this.$confirm(`确认要${text}“${row.trueName}”用户吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
        .then(() => {
          return postUserStatus({
            id: row.id,
            isValid: row.isValid,
          });
        })
        .then(() => {
          this.$message.success(text + "成功");
          this.getUserList();
        })
        .catch(() => {
          // 用户取消时还原状态
          row.isValid = row.isValid === 1 ? 2 : 1;
        });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        departmentId: undefined,
        departmentName: undefined,
        email: undefined,
        id: undefined,
        phone: undefined,
        roleIds: [],
        sexId: undefined,
        sexName: undefined,
        trueName: undefined,
        userName: undefined,
        userPwd: undefined,
        isValid: 1,
      };
      // this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryUser.page = 1;
      this.getUserList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      this.queryUser = {
        page: 1,
        limit: 10,
        orderBy: "",
      };
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.userId);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },
    // 更多操作触发
    handleCommand(command, row) {
      switch (command) {
        case "handleResetPwd":
          this.handleResetPwd(row);
          break;
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加用户";
      this.form.password = this.initPassword;
      // });
    },
    /** 修改按钮操作 */
    async handleUpdate(row) {
      this.reset();
      let { data } = await getIDUser(row.id);
      this.form = data;
      this.open = true;
      this.title = "修改用户";
      this.form.password = "";
    },
    /** 重置密码按钮操作 */
    handleResetPwd(row) {
      this.$confirm(
        `确认要重置用户 "${row.trueName || row.userName}" 的密码吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
        }
      )
        .then(() => {
          return restPassword(row.id);
        })
        .then((response) => {
          // 如接口返回新密码可从 response 中取出，否则使用默认提示
          const newPwd =
            response && response.data && response.data.password
              ? response.data.password
              : "123456";
          this.$message.success("重置成功，新密码是：" + newPwd);
        })
        .catch(() => {
          // 用户取消或接口错误时不做额外操作
        });
    },

    /** 提交按钮 */
    submitForm: function () {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          if (this.form.id != undefined) {
            delete this.form.userName;
            let res = await postUserUpdate(this.form);
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.open = false;
            this.getUserList();
          } else {
            let res = await postUserInsert(this.form);
            this.$message({
              message: "新增成功",
              type: "success",
            });
            this.open = false;
            this.getUserList();
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm('是否确认删除用户名为"' + row.userName + '"的数据项？')
        .then(function () {
          return postUserDelete([row.id]);
        })
        .then(() => {
          this.getUserList();
          this.$message.success("删除成功");
        })
        .catch(() => {});
    },

    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      this.upload.open = false;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();
      this.$alert(
        "<div style='overflow: auto;overflow-x: hidden;max-height: 70vh;padding: 10px 20px 0;'>" +
          response.msg +
          "</div>",
        "导入结果",
        { dangerouslyUseHTMLString: true }
      );
      this.getUserList();
    },
    // 提交上传文件
    submitFileForm() {
      this.$refs.upload.submit();
    },
    /** 根据部门ID获取部门名称 */
    getDeptNameById(departmentId) {
      // 递归查找部门名称
      function findDept(depts, id) {
        for (let dept of depts) {
          if (dept.id === id) return dept.name;
          if (dept.children) {
            const name = findDept(dept.children, id);
            if (name) return name;
          }
        }
        return "";
      }
      return findDept(this.deptOptions, departmentId);
    },
  },
};
</script>
<style lang="scss" scoped>
.head-container {
  height: 80vh;
  overflow: auto;
  padding: 0 10px;
  margin-right: 10px;
  border-right: 1px solid #ebeef5;

  // 自定义滚动条样式
  &::-webkit-scrollbar {
    width: 8px;
    background: #f5f7fa;
  }
  &::-webkit-scrollbar-thumb {
    background: #c0c4cc;
    border-radius: 4px;
    &:hover {
      background: #909399;
    }
  }
  &::-webkit-scrollbar-track {
    background: #f5f7fa;
    border-radius: 4px;
  }
}
::v-deep .compact-table .el-table__cell {
  padding: 13px 0 !important;
  /* 可根据需要调整为更紧凑或更宽松 */
}

::v-deep .compact-table .el-table__header .el-table__cell {
  padding: 20px 0 !important;
}
</style>
